export default "__VITE_ASSET__BiDjk5ve__"